<template>
  <div>
    <SiteBanner :site-address="siteAddress" :site-name="siteName" />
    <div class="p-4">
      <h1 class="mb-2 p-2 text-center text-lg">Site Selected</h1>
      <div class="w-full">
        <MapWithPin :center="center" />
      </div>
      <p class="my-2 pt-1 text-center text-xl">Is this the correct site?</p>
      <div class="flex space-x-4 pt-3">
        <SecondaryButton
          type="button"
          action="NO"
          identifier="NoBtn"
          @click.once="backToSiteList"
        />
        <PrimaryButton
          type="button"
          action="YES"
          identifier="YesBtn"
          @click.once="confirmSite"
        />
      </div>
      <LoadingView :is-loading="isLoading" message="Retrieving companies..." />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue'
  import PrimaryButton from '@/components/PrimaryButton.vue'
  import MapWithPin from '@/components/MapWithPin.vue'
  import { useRouter } from 'vue-router'
  import LoadingView from '@/views/LoadingView.vue'
  import SiteBanner from '@/components/SiteBanner.vue'
  import InvalidStoreException from '@/exceptions/InvalidStoreException'
  import SecondaryButton from '@/components/SecondaryButton.vue'
  import { useBypassStore } from '@/storage/bypass'
  import { storeToRefs } from 'pinia'
  import { useSiteStore } from '@/storage/site'
  import { useUserStore } from '@/storage/user'
  import { useCustomerStore } from '@/storage/customer'

  const { setAuthorisedContractorCompanies, setSelectionConfirmed } =
    useSiteStore()
  const {
    address: siteAddress,
    name: siteName,
    latitude: siteLatitude,
    longitude: siteLongitude,
    isSiteStoreDefault,
  } = storeToRefs(useSiteStore())
  const router = useRouter()
  const { activeVendorsForBrand } = useUserStore()
  const { id: brandId } = storeToRefs(useCustomerStore())
  const { isUserStoreDefault } = storeToRefs(useUserStore())
  const { setScanBypassed } = useBypassStore()
  const isLoading = ref(false)

  async function backToSiteList(): Promise<void> {
    setSelectionConfirmed(false)
    await router.replace({ name: 'selectBypassSites' })
  }

  const center = {
    lat: siteLatitude.value,
    lng: siteLongitude.value,
  }

  async function confirmSite(): Promise<void> {
    isLoading.value = true

    if (isSiteStoreDefault.value || isUserStoreDefault.value) {
      throw new InvalidStoreException()
    }
    const activeVendorForBrand = activeVendorsForBrand(brandId.value)

    if (activeVendorForBrand.length === 0) {
      await router.replace({ name: 'noAccessToSite' })
    }

    if (activeVendorForBrand.length > 0) {
      setScanBypassed(true)
      setSelectionConfirmed(true)
      setAuthorisedContractorCompanies(activeVendorForBrand)
      await router.replace({ name: 'contractorCompanySelection' })
    }

    isLoading.value = false
  }
</script>
